import { render, staticRenderFns } from "./DynamicPageCreate.vue?vue&type=template&id=ef1a8440&scoped=true&"
import script from "./DynamicPageCreate.vue?vue&type=script&lang=js&"
export * from "./DynamicPageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a8440",
  null
  
)

export default component.exports